import { CheckCircle2, Circle, XCircle } from "lucide-react";
import { FILING_STEPS } from "@/lib/constants";

export const FilingTimeline = ({ status, sr22 = true }) => {
  if (status === "not_required") {
    return (
      <div className="flex items-center gap-3 rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-emerald-800" data-testid="filing-status-timeline">
        <CheckCircle2 className="h-5 w-5" /> Your policy is active. No state filing is required for this policy.
      </div>
    );
  }
  if (status === "cancelled") {
    return (
      <div className="flex items-center gap-3 rounded-lg border border-red-200 bg-red-50 p-4 text-red-700" data-testid="filing-status-timeline">
        <XCircle className="h-5 w-5" /> {sr22 ? "This policy was cancelled and an SR26 notice was filed with the state." : "This policy was cancelled."}
      </div>
    );
  }
  const idx = FILING_STEPS.findIndex((s) => s.key === status);
  return (
    <ol className="grid gap-4 md:grid-cols-4" data-testid="filing-status-timeline">
      {FILING_STEPS.map((s, i) => {
        const done = i <= idx;
        return (
          <li key={s.key} className="relative" data-testid={`filing-step-${s.key}`}>
            <div className={`mb-3 h-1 rounded-full ${done ? "bg-emerald-500" : "bg-slate-200"}`} />
            <div className="flex items-start gap-2">
              {done ? <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" /> : <Circle className="mt-0.5 h-5 w-5 shrink-0 text-slate-300" />}
              <div>
                <p className={`text-sm font-semibold ${done ? "text-slate-900" : "text-slate-400"}`}>{s.label}</p>
                <p className="text-xs text-slate-500">{s.desc}</p>
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
};
